import React from "react";
import Geolocation from "react-geolocation";

export default props => {
  //console.log("these are props", props);
  return (
    <Geolocation
      onSuccess={data => {
        props.mylocation(data);
        //console.log(data);
      }}
      render={({
        fetchingPosition,
        position: { coords: { latitude, longitude } = {} } = {},
        error,
        getCurrentPosition
      }) => (
        <div>
          {/*
          <button onClick={getCurrentPosition}>Get Position</button>
          {error && <div>{error.message}</div>}
          <pre>
            latitude: {latitude}
            longitude: {longitude}
          </pre>
*/}
        </div>
      )}
    />
  );
};



// WEBPACK FOOTER //
// ./src/Features/Location/Geolocation.js